import { render, staticRenderFns } from "./DashCredor.vue?vue&type=template&id=0a7b44bd"
import script from "./DashCredor.vue?vue&type=script&lang=js"
export * from "./DashCredor.vue?vue&type=script&lang=js"
import style0 from "./DashCredor.vue?vue&type=style&index=0&id=0a7b44bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports